import { apiService } from '@/services/APIService';
import { rHandler } from '@/plugins/RHandler';
import { rServices } from '@/plugins/api';
import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import Nomination from '../list/nomination';
import { DEFAULT_NOMINATION } from '@/modules/Events/constants';
import NominationOptions from '../list/nomination-options';

const API_PATH = 'nominations';
const API_PATH_EVENTS = 'event-nominations';
const API_PATH_OPTIONS = 'event-nomination-options';

export const NominationsManager = {
  objects: objectsRHandler(API_PATH, Nomination),

  events: {
    ...objectsRHandler(API_PATH_EVENTS, Nomination),
    async fullDelete({ args, data } = DEFAULT_PARAMS) {
      const [eventId, id] = args;
      // Убираем экспертов
      const { response: expertsResponse } = await rServices.expertise.getExperts({ args: [eventId] });
      const experts = (expertsResponse?.data?.data || []).filter((expert) => {
        const nominations = (expert?.nomination_ids || []).map((item) => item.nomination_id);
        return nominations.includes(id);
      });
      const expertsBullets = experts.map((expert) => {
        const params = {
          user_ids: [expert.id],
          nomination_ids: [id],
        };
        return rServices.expertise.detachExperts({ args: [eventId, params] });
      });
      // Убираем этапы
      const { response: stagesResponse } = await rServices.events.getStages({ params: {
        'search[event_id]': eventId,
        'search[nomination_id]': id,
      } });
      const stages = stagesResponse.data?.data;
      const stagesBullets = stages.map((stage) => rServices.events.deleteStage({ args: [stage.id] }));
      await Promise.all([...expertsBullets, ...stagesBullets]);
      // Убираем номинацию
      return rHandler(
        apiService.delete(`${API_PATH_EVENTS}/${id}`, data),
        (response) => ({ response }),
        (error) => ({ error }),
      );
    },
  },

  options: objectsRHandler(API_PATH_OPTIONS, NominationOptions),

  all({ params } = DEFAULT_PARAMS) {
    return rHandler(
      apiService.get(API_PATH_EVENTS, params),
      (response) => ({
        response,
        items: response.data.data
          .map((nomination) => new Nomination(nomination, API_PATH_EVENTS))
          .filter(({ name }, _, arr) => (arr.length > 1 ? name !== DEFAULT_NOMINATION.NAME : true)),
      }),
      (error) => ({ error }),
    );
  },
};
